export default __webpack_public_path__ + "static/media/krilnekapije.ef17d16b.png";